import { Box, IconButton, Skeleton, Tooltip } from '@mui/material';
import React, { useCallback } from 'react';
import Attachments from '../../../attachments/Attachments';
import { SECURITY_ACTIONS, useSecurity } from '../../../auth/Security';
import I18n, { useI18n } from '../../../i18n/I18n';
import { Icons } from '../../../icons/Icons';
import { PanelNoAccess } from '../../ui/components/PanelNoAccess';
import { usePanelCommands } from '../../ui/hooks/usePanelCommands';
import { usePanelSession } from '../../ui/hooks/usePanelSession';

const pendingSx = { p: 2 };

export function AttachmentsSidePanel() {
    const { subject } = usePanelSession();
    const { close } = usePanelCommands();
    const t = useI18n();
    const handleClose = useCallback(() => {
        close();
    }, [close]);
    const decision = useSecurity(SECURITY_ACTIONS.COMMENT, {
        entityName: subject?.entityName,
        entitySecurity: subject?.security
    });
    const closeLabel = t('dialog.close');
    const closeAffordance = (
        <Tooltip title={closeLabel}>
            <IconButton aria-label={closeLabel} data-testid="attachments-panel-close" onClick={handleClose}>
                <Icons.Close />
            </IconButton>
        </Tooltip>
    );

    if (decision.pending) {
        return (
            <Box sx={pendingSx} role="status" aria-busy="true" data-testid="attachments-panel-pending">
                {closeAffordance}
                <Skeleton variant="rectangular" height={160} />
            </Box>
        );
    }
    if (!subject?.reference.id || !decision.allowed) return <PanelNoAccess hint={closeAffordance} />;

    return (
        <Attachments
            key={`${subject.entityName}:${subject.reference.id}`}
            id="attachments"
            entity={subject.entityName}
            entityReference={subject.reference}
            title={
                <I18n
                    token="attachments.panel.title"
                    values={{ entityName: subject.label ?? subject.reference.label }}
                />
            }
            onClose={handleClose}
        />
    );
}
